// extracted by mini-css-extract-plugin
module.exports = {"container":"TutorialDashboard_container__23oMX","cardItem":"TutorialDashboard_cardItem__Q6DCh"};